var map = {
	"./Business-Data.svg": "07e1",
	"./CRM-Management.svg": "bf23",
	"./Cloud-based.svg": "d3e1",
	"./Contactless-Checkout.svg": "4b63",
	"./Delivery-Platform.svg": "0feb",
	"./Digital-Menus.svg": "4b08",
	"./Group-1519.svg": "bff5",
	"./Inventory-Management.svg": "1a63",
	"./Kitchen-Order.svg": "c179",
	"./One-stop.svg": "36eb",
	"./Reception-Management.svg": "d5b6",
	"./Save-Money.svg": "6c12",
	"./TikTok.svg": "5c85",
	"./Trusted-By.svg": "9f7c",
	"./YouTube.svg": "30be",
	"./arr.svg": "d744",
	"./back.svg": "972b",
	"./bar.svg": "eed4",
	"./barm.svg": "dff0",
	"./bdor.svg": "e073",
	"./bran.svg": "9c15",
	"./card.svg": "0cb1",
	"./circl.svg": "fe69",
	"./cl.svg": "8435",
	"./clock.svg": "9f74",
	"./close.svg": "864a",
	"./com.svg": "e8eb",
	"./digital.svg": "1406",
	"./doll.svg": "3333",
	"./dollor.svg": "fd43",
	"./dollor1.svg": "b376",
	"./dou.svg": "c02c",
	"./ear.svg": "17f1",
	"./er.svg": "aa72",
	"./face.svg": "48e4",
	"./face1.svg": "4bc5",
	"./fee.svg": "1d49",
	"./git.svg": "3147",
	"./glob.svg": "f207",
	"./google.svg": "9f6f",
	"./hand.svg": "fd75",
	"./home-p1.svg": "cd8b8",
	"./home-p2.svg": "c01f",
	"./home-p3.svg": "35bc",
	"./ht.svg": "aef6",
	"./icon.svg": "9f4c",
	"./icon1.svg": "ad0e",
	"./icon2.svg": "c97b",
	"./in.svg": "397a",
	"./inst.svg": "1ac7",
	"./ios.svg": "8da9",
	"./line.svg": "a6d9",
	"./linkin.svg": "1e2d",
	"./mony.svg": "47a4",
	"./mu.svg": "72bb",
	"./muw.svg": "7c81",
	"./navl.svg": "3001",
	"./navr.svg": "29c1",
	"./noint.svg": "bb49",
	"./note.svg": "5ea5",
	"./pai.svg": "02e8",
	"./pep.svg": "edb5",
	"./phon.svg": "73ab",
	"./phone1.svg": "787b",
	"./plat.svg": "0c58",
	"./rgul.svg": "eea2",
	"./sit.svg": "f730",
	"./soon.svg": "d8c9",
	"./star.svg": "4e5a",
	"./tele.svg": "d281",
	"./trr.svg": "1806",
	"./tw.svg": "eeb0",
	"./u14.svg": "d21d",
	"./u15.svg": "7f9f",
	"./union.svg": "17bc",
	"./vv.svg": "47d5",
	"./world.svg": "d4af",
	"./x.svg": "ac26",
	"./xx.svg": "7b2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";